import { __ } from '@wordpress/i18n';
import { cog } from '@wordpress/icons';
import { store as coreStore } from '@wordpress/core-data';
import { useDispatch, useSelect } from '@wordpress/data';
import { RulesTabs } from '../../../modal-conditions/index.js';

const displayRules = {
	id: 'edit-rules',
	label: __( 'Display rules' ),
	icon: cog,
	isPrimary: true,
	isEligible( { status } ) {
		return status !== 'trash';
	},
	supportsBulk: false,
	hideModalHeader: false,
	RenderModal: ( { items: posts, closeModal } ) => {
		const popper = posts[ 0 ];
		const { saveEditedEntityRecord } = useDispatch( coreStore );

		const { isSaving, hasEdits } = useSelect(
			( select ) => ( {
				isSaving: select( coreStore ).isSavingEntityRecord(
					'postType',
					'popper',
					popper.id
				),
				hasEdits: select( coreStore ).hasEditsForEntityRecord(
					'postType',
					'popper',
					popper.id
				),
			} ),
			[]
		);

		const handleSave = () => {
			saveEditedEntityRecord( 'postType', 'popper', popper.id ).then(
				() => closeModal()
			);
		};
		return (
			<RulesTabs
				postId={ popper.id }
				onRequestClose={ handleSave }
				isSaving={ isSaving }
			/>
		);
	},
};

export default displayRules;
